export default {
  methods: {
    isValid() {
      this.$v.$touch()
      if (this.$v.$error) {
        this.$nextTick(() => {
          document.querySelector('.pk-input--error').focus()
        })
      }

      return !this.$v.$error
    }
  }
}
